import { GET } from '../request'

export const getAsistenciaFormacionList = ({ fecha, hora }) =>
  GET('/api/profes/planificacion/asistencia-formacion/list', { fecha, hora })

export const getAsistenciasFormacion = ({ formacion }) =>
  GET('/api/profes/planificacion/asistencia-formacion/list/formacion', {
    formacion
  })
